import { html } from 'lit';
import { sectionHeading } from '../components/sectionHeading.js';
import type { LandingContent } from '../../shared/content/landingContent.js';
import { editorSemanticText } from '../editor/editorSemanticText.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

export const knowledgeSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => html`
  <section
    class=${editorNodeClass(editor, 'section.knowledge', 'vp-section vp-knowledge-section')}
    style=${editorNodeStyle(editor, 'section.knowledge')}
    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.knowledge', event)}
    @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.knowledge', event)}
  >
    <div class="vp-shell">
      ${sectionHeading({
        eyebrow: content.knowledge.eyebrow,
        title: content.knowledge.title,
        highlight: content.knowledge.titleHighlight,
        text: content.knowledge.text,
        align: 'center',
        editor,
        elementPrefix: 'knowledge',
      })}

      <div
        class=${editorNodeClass(editor, 'knowledge.cards', 'vp-card-grid vp-card-grid-four vp-knowledge-grid')}
        style=${editorNodeStyle(editor, 'knowledge.cards')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'knowledge.cards', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'knowledge.cards', event)}
      >
        ${content.knowledge.articles.map(
          (article, index) => html`
            <a
              class=${editorNodeClass(editor, `knowledge.card.${index}`, 'vp-knowledge-card reveal-card')}
              style=${editorNodeStyle(editor, `knowledge.card.${index}`)}
              href=${article.href}
              @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `knowledge.card.${index}`, event)}
              @click=${(event: MouseEvent) => {
                if (editor?.mode === 'editor') event.preventDefault();
                editorNodeClick(editor, `knowledge.card.${index}`, event);
              }}
            >
              <span
                class=${editorNodeClass(
                  editor,
                  `knowledge.card.${index}.icon`,
                  `${article.iconClass} vp-knowledge-card-icon`,
                )}
                style=${editorNodeStyle(editor, `knowledge.card.${index}.icon`)}
                @pointerdown=${(event: PointerEvent) =>
                  editorNodePointerDown(editor, `knowledge.card.${index}.icon`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `knowledge.card.${index}.icon`, event)}
              ></span>
              <span
                class=${editorNodeClass(editor, `knowledge.card.${index}.eyebrow`, 'vp-knowledge-card-eyebrow')}
                style=${editorNodeStyle(editor, `knowledge.card.${index}.eyebrow`)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `knowledge.card.${index}.eyebrow`, event)}
                >${article.eyebrow}</span
              >
              ${editorSemanticText({
                editor,
                elementId: `knowledge.card.${index}.title`,
                fallbackTag: 'h3',
                content: article.title,
              })}
              ${editorSemanticText({
                editor,
                elementId: `knowledge.card.${index}.text`,
                fallbackTag: 'p',
                content: article.text,
              })}
              <span class="vp-knowledge-card-link">
                <span
                  class=${editorNodeClass(editor, `knowledge.card.${index}.linkLabel`)}
                  style=${editorNodeStyle(editor, `knowledge.card.${index}.linkLabel`)}
                  @click=${(event: MouseEvent) => editorNodeClick(editor, `knowledge.card.${index}.linkLabel`, event)}
                  >${article.linkLabel}</span
                >
                <span class="icon-[material-symbols--arrow-outward]" aria-hidden="true"></span>
              </span>
            </a>
          `,
        )}
      </div>
    </div>
  </section>
`;
